<template>
  <v-list-item flat>
    <v-list-item-content>
      <v-list-item-title class="d-flex justify-space-between">
        <span class="itemName">{{name}}</span>
        <span class="itemValue">{{count}}</span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    count: {
      type: [String, Number],
      required: true
    }
  }
};
</script>

<style scoped>
.itemName {
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.32px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #000000;
}

.itemValue {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #0012a6;
}
</style>